import { tickerItems } from "@/mocks/news";

export default function TickerBar() {
  return (
    <div className="flex items-center overflow-hidden border-b border-background-200 bg-primary-600 text-background-50">
      <div className="relative z-10 flex shrink-0 items-center gap-1.5 px-4 py-2 md:px-6">
        <span className="flex items-center gap-1 rounded-full bg-background-50/20 px-2 py-0.5 text-xs font-semibold">
          <i className="ri-broadcast-line" />
          滚动热讯
        </span>
      </div>
      <div className="relative flex flex-1 items-center overflow-hidden py-2">
        <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
          {[...tickerItems, ...tickerItems].map((item, idx) => (
            <span key={idx} className="flex items-center gap-2 text-sm">
              <i className="ri-flashlight-fill text-accent-300" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}